<template>
  <b-popover
    triggers="hover"
    placement="top"
    :target="target"
    custom-class="popover-deal"
  >
    <template #default>
      <div class="popover-content-deal">
        <div class="deal-title text-overflow">
          {{ title }}
        </div>

        <div class="deal-description text-overflow">
          {{ description }}
        </div>

        <div class="deal-price">${{ decimalFixed(price) }}</div>
      </div>
    </template>
  </b-popover>
</template>
  
<script>
import { decimalFixed} from '@/libs/utils/formats'
import { BPopover } from "bootstrap-vue";
export default {
  name: 'popoverInfoDeal',
  components: {
    BPopover,
  },
  props: {
    target: {
      type: String,
      required: true,
    },

    title: {
      type: String,
      default: "",
    },

    description: {
      type: String,
      default: "",
    },

    price: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      decimalFixed,
    }
  },

  methods: {
  },
};
</script>
<style scoped>
.popover-deal {
  overflow: hidden;
}
.popover-content-deal {
  max-width: 260px;
  padding: 4px 6px;
}

.deal-title {
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 6px;
}

.deal-description {
  font-size: 13px;
  color: #6c757d;
  line-height: 1.4;
  margin-bottom: 8px;
}

.deal-price {
  font-weight: 700;
  font-size: 15px;
  color: #0096fe;
}
.text-overflow {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>